export const getByPath = (path: string[], object: Record<string, any>): any => {
  let location = object;
  for (const direction of path) {
    location = location?.[direction] ?? null;
  }
  return location;
};
